import axios from 'axios';

export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5041/api';

export const api = axios.create({ baseURL: API_BASE });

export function getApiErrorMessage(error, fallback) {
  const responseData = error?.response?.data;

  if (typeof responseData === 'string') return responseData;
  if (responseData?.detail) return responseData.detail;
  if (responseData?.title) return responseData.title;

  return error?.message || fallback;
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
